import React, { useState, useRef, useEffect } from 'react';

export const TransitionWrapper = ({
    show,
    children,
    durationMs = 300,
    transitionType = 'fade',
    inline,
}) => {
    const [visible, setVisible] = useState(show);
    const count = useRef(0);

    useEffect(() => {
        count.current++;
        show && setVisible(true);
    }, [show]);

    const handleAnimationEnd = () => {
        !show && setVisible(false);
    };

    const animIn = `${count.current >= 2 ? transitionType : 'fade'}-in`;
    const animOut = `${count.current >= 1 ? transitionType : 'fade'}-out`;

    return visible ? (
        <div
            style={{ animation: `${show ? animIn : animOut} ${durationMs}ms` }}
            onAnimationEnd={handleAnimationEnd}
        >
            {children}
        </div>
    ) : null;
}